import clsx from "clsx";

import { TabWithDisableHint } from "@/components/Interface/TabWithDisableHint/TabWithDisableHint";

export type TabElement = {
  hidden?: boolean;
  target: string;
  disabled: boolean;
  /** Single sentence explaining why the tab cannot be opened right now. */
  disabledHint?: string;
  text: string;
};

/**
 * Figma `dire-tab-group`: a single-row, horizontally scrollable strip of
 * `dire-tab` pills. Tabs scroll sideways when they overflow; they must not
 * wrap or scroll vertically.
 */
export const Tablist = ({
  className,
  tabs,
}: {
  className?: string;
  tabs: TabElement[];
}) => (
  <nav className={clsx("flex items-center gap-2", className)}>
    <div
      className="flex min-w-0 flex-1 touch-pan-x flex-nowrap items-center gap-2 overflow-x-auto overflow-y-hidden overscroll-y-none [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      role="tablist"
    >
      {tabs
        .filter(({ hidden }) => !hidden)
        .map(({ target, disabled, disabledHint, text }) => (
          <TabWithDisableHint
            key={target}
            target={target}
            disabled={disabled}
            disabledHint={disabledHint}
          >
            {text}
          </TabWithDisableHint>
        ))}
    </div>
  </nav>
);
